import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { ResponsiveHtmlDirective } from '../../../utils/responsivehtml'; // Caminho para o arquivo da diretiva


import { SharedUtil } from '../../../core/utils/SharedUtil';
import { Cargo } from '../../../models/cargo.model';
import { VotoService } from '../../../services/voto.service';
import { CargoService } from '../../../services/cargo.service';
import { CanditadosService } from '../../../services/canditados.service';
import { Candidato } from '../../../models/candidato.model';
import { Voto } from 'src/app/models/voto.model';
import { LoginService } from '../../../services/login-participante.service';
import { LoginParticipante } from '../../../models/login-participante.model';

import { ConfirmationService, Message, MessageService } from 'primeng/api';
import { StorageService } from 'src/app/services/storage.service';
import { Eleicao } from 'src/app/models/eleicao.model';
import { EleicaoService } from 'src/app/services/eleicao.service';
import { CandidatoVoto } from 'src/app/models/candidatovoto.model';
import { ComprovanteService } from 'src/app/services/comprovante.service';
import { NgxSpinnerService } from 'ngx-spinner';
import sortBy from 'sort-by';

import * as moment from 'moment';


@Component({
  selector: 'app-canditado-listar',
  templateUrl: './canditado-listar.component.html',
  providers: [ConfirmationService],
  animations: [
    trigger('rowExpansionTrigger', [
      state('void', style({
        transform: 'translateX(-10%)',
        opacity: 0
      })),
      state('active', style({
        transform: 'translateX(0)',
        opacity: 1
      })),
      transition('* <=> *', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)'))
    ])
  ],
  styles: [`
  .preline {
    white-space: pre-line;
  }

  /* Libera a quebra de linha na célula da coluna 'nome' */
  :host ::ng-deep .p-datatable .p-datatable-tbody > tr > td.wrap-col-nome,
  :host ::ng-deep .ui-table .ui-table-tbody > tr > td.wrap-col-nome {
    white-space: normal !important;
    overflow: visible !important;
    text-overflow: clip !important;
    word-break: break-word;
    overflow-wrap: anywhere;
  }

  :host ::ng-deep button {
    margin-right: .25em;
  }

  :host ::ng-deep .custom-toast .ui-toast-message {
    color: #ffffff;
    background: #FC466B;
    background: -webkit-linear-gradient(to right, #3F5EFB, #FC466B);
    background: linear-gradient(to right, #3F5EFB, #FC466B);
  }

  :host ::ng-deep .custom-toast .ui-toast-close-icon {
    color: #ffffff;
  }
`],
})


export class CanditadoListarComponent implements OnInit {
  @Input() eleicaoParametrizacao: any;
  @Input() cargo: Cargo;

  msgs: Message[] = [];
  cols: any[];
  candidatosSelecionados: CandidatoVoto[] = [];
  expandedRows: { [key: string]: boolean } = {}; 
  votos: CandidatoVoto[] = [];
  cargos: Cargo[] = [];
  eleicao: any;
  quantidadeEleito: number;

  dataHoraInicio: any;
  dataHoraFim: any;

  voto: Voto = new Voto(); /*Esta sendo usado?*/
  candidato: Candidato = new Candidato();
  participante: any;
  desabilitaCheckbox: Boolean = false;
  desabilitaBotao: Boolean = true;
  candidatoJustificativaSelecionado: Boolean = false;
  infoUsuario: any;
  token: any;
  tituloEleicao: any;
  idEleitor: any;
  rotaEleicao: string;
  validaEntidadeEleicao: boolean = false;
  titleViva: boolean = false;
  votoUnique: boolean = false;
  justificados: boolean;
  isAssembleia: boolean = false;
  formato : string;
  labelSelecao : string;
  temCandidaturas : boolean = false;


  constructor(
    private confirmationService: ConfirmationService,
    protected cargoServices: CargoService,
    protected eleicaoService: EleicaoService,
    protected comprovanteService: ComprovanteService,
    protected router: Router,
    protected route: ActivatedRoute,
    protected messageService: MessageService,
    protected candidatoService: CanditadosService,
    protected votoServices: VotoService,
    protected sharedUtil: SharedUtil,
    protected loginServices: LoginService,
    private spinner: NgxSpinnerService,
    protected storage: StorageService
  ) { }

  ngOnInit() {
    this.spinner.show();
    this.token = sessionStorage.getItem("token");
    if (this.eleicaoParametrizacao) {
      this.eleicao = this.eleicaoParametrizacao;
      this.temCandidaturas = this.eleicao.temCandidaturas;
      this.participante = sessionStorage.getItem('infoGestor');
      this.formato="YYYY-MM-DDTHH:mm:ss'Z'";
    } else {
      this.formato="YYYY-MM-DDTHH:mm:ss'z'";
      this.rotaEleicao = sessionStorage.getItem("rotaEleicao");
      this.eleicao = JSON.parse(sessionStorage.getItem("eleicao"));
      this.participante = JSON.parse(sessionStorage.getItem('infoEleitor'));
      this.idEleitor = this.participante.id;
      this.temCandidaturas = this.eleicao.temCandidaturas;
      var eleicaoEncerrada = sessionStorage.getItem("eleicaoEncerrada");
      if (eleicaoEncerrada === "true") {
        this.router.navigate(['../../eleitor/comprovante'], { relativeTo: this.route });
        this.spinner.hide();
      } else {
        this.obterListaCandidatosOuRedirecionarPagComprovanteVotacao(this.eleicao.id, this.token);
      }
    }
    
    this.dataHoraInicio = moment(this.eleicao.dataHoraInicio, this.formato).format('DD/MM/YYYY HH:mm');
    this.dataHoraFim = moment(this.eleicao.dataHoraFim, this.formato).format('DD/MM/YYYY HH:mm');
    this.tituloEleicao = this.eleicao.titulo;
    if (this.rotaEleicao) {
      this.validaEntidadeEleicao = this.rotaEleicao.toLowerCase().includes('vivaprevidencia');
      //checar se tem a string 'viva' na rota da eleição.
      const substring = "viva";
      if (this.rotaEleicao.includes(substring)) {
        this.titleViva = true;
      }
    }
    this.cols = [
      { field: 'nome', header: 'Nome' },
    ];

    /*Verifica se uma eleição é assembleia pelo titulo, medida provissória: */
    if (this.tituloEleicao.includes('assembleia') || this.tituloEleicao.includes('Assembleia')) {
      this.isAssembleia = true;
    }
  }


  public selecionarCandidato(event, candidatosSelecionados) {
    let candidatoEleito = this.candidatosSelecionados.length;
    this.desabilitaBotao = false;
    if (event.data.votoJustificavel) {//Apenas para validar candidatos com justificativa
      candidatosSelecionados.expandedRowKeys[event.data.nome] = true;
      event.data.selecionado = true;
      this.candidatoJustificativaSelecionado = true;
    }
    if (candidatoEleito >= this.cargo.quantidadeEleitos) {
      this.desabilitaCheckbox = true;
    }
  }

  public desmarcarSelecao(event, candidatosSelecionados) {
    this.desabilitaBotao = true;
    if (event.data.votoJustificavel) {
      candidatosSelecionados.expandedRowKeys[event.data.nome] = false; //Apenas para validar candidatos com justificativa
      event.data.selecionado = false;
      this.candidatoJustificativaSelecionado = false;
    }
  }

  //listarCandidatos e redirecionar para pagina de comprovação caso ja tenha votados em todos os candidatos:
  public async obterListaCandidatosOuRedirecionarPagComprovanteVotacao(idEleicao: number, token) {

    this.comprovanteService.getComprovanteVotoPorIdEleitor(this.idEleitor, token).then((result: any) => {
      this.comprovanteService.validaCandidatosAVotar(idEleicao, result, token).then((res: Cargo[]) => {
        if (res.length > 0) {
          this.labelSelecao = res[0].labelCargo;
          this.cargo = res[0];
          this.quantidadeEleito = this.cargo.quantidadeEleitos;
          if(this.temCandidaturas){
            this.cargo.candidatos = this.cargo.candidatos.sort(sortBy('nome'));
          }
          this.spinner.hide();
        } else {
          this.router.navigate(['../../eleitor/comprovante'], { relativeTo: this.route });
          this.spinner.hide();
        }
      }).catch(err => {
        this.router.navigate(['/error-sessao']);
      });
    })
  }


  public limparCandidatosSelecioandos(candidatosList?) {
    this.candidatosSelecionados = [];
    this.desabilitaCheckbox = false;
    this.desabilitaBotao = true;
    this.candidatoJustificativaSelecionado = false;
    this.collapseAll(candidatosList);
    this.cargo.candidatos.forEach(c => { c.selecionado = false })
  }


  collapseAll(candidatosList) { candidatosList.expandedRowKeys = {}; }

  public logout() {
    this.confirmationService.confirm({
      message: 'Tem certeza que deseja sair?',
      accept: () => {
        this.loginServices.logout();
        this.router.navigate(['../../'], { relativeTo: this.route });
      },
      reject: () => {
        this.desabilitaBotao = true;
        this.messageService.add({ key: 'toast', severity: 'warn', summary: 'Informação', detail: 'Operação cancelada!' });
        setTimeout(() => {
          this.limparCandidatosSelecioandos();
        }, 700);
      },
    });
  }

  public realizarVotoNulo(candidatosList) {
    this.limparCandidatosSelecioandos(candidatosList);
    if (this.candidatosSelecionados.length <= 0) {
      let compMsg = this.isAssembleia ? ' a pauta ' : ' o cargo ';
      this.confirmationService.confirm({
        message: 'Você optou por <strong>ANULAR</strong> seu voto '
          + ' para' + compMsg + '<strong>' + this.cargo.nome + '</strong>.'
          + ' Clique em <strong>SIM</strong> para confirmar seu voto'
          + ' ou em <strong>NÃO</strong> para revisar sua opção.',
        accept: () => {
          let votosCandidatos = this.candidatosSelecionados;
          this.votos = votosCandidatos;
          if (this.votos.length == 0) {
            this.votoServices.saveVotoNulo(this.cargo.id, this.token).then(votoNulo => {
              this.messageService.add({ key: 'toast', severity: 'success', summary: 'Informação', detail: 'Voto anulado com sucesso' });
              setTimeout(() => {
                location.reload()
              }, 700);
            }, error => {
              this.messageService.add({ key: 'toast', severity: 'error', summary: 'Atenção', detail: 'Voto não computado' });
              setTimeout(() => {
                location.reload()
              }, 700);
            });
          }
        },
        reject: () => {
          this.desabilitaBotao = true;
          this.messageService.add({ key: 'toast', severity: 'warn', summary: 'Informação', detail: 'Operação cancelada!' });
          setTimeout(() => {
            this.limparCandidatosSelecioandos();
          }, 700);
        }
      });
    }
  }


  public realizarVotosEmBranco(candidatosList) {
    this.limparCandidatosSelecioandos(candidatosList);
    if (this.candidatosSelecionados.length == 0) {
      let compMsg = this.isAssembleia ? ' a pauta ' : ' o cargo ';

      this.confirmationService.confirm({
        message: 'Você optou por votar em <strong>BRANCO</strong> '
          + ' para' + compMsg + '<strong>' + this.cargo.nome + '</strong>.'
          + ' Clique em <strong>SIM</strong> para confirmar seu voto'
          + ' ou em <strong>NÃO</strong> para revisar sua opção.',
        accept: () => {
          let votosCandidatos = this.candidatosSelecionados;
          this.votos = votosCandidatos;
          if (this.votos.length == 0) {
            this.votoServices.saveVotosEmBrancoGeral(this.cargo.id, this.token).then(result => {
              this.messageService.add({ key: 'toast', severity: 'success', summary: 'Informação', detail: 'Voto realizado com sucesso' });
              setTimeout(() => {
                location.reload()
              }, 700);
            }, error => {
              this.messageService.add({ key: 'toast', severity: 'error', summary: 'Atenção', detail: 'Voto não computado' });
              setTimeout(() => {
                location.reload()
              }, 700);
            });
          }
        },
        reject: () => {
          this.desabilitaBotao = true;
          this.messageService.add({ key: 'toast', severity: 'warn', summary: 'Informação', detail: 'Operação cancelada!' });
          setTimeout(() => {
            this.limparCandidatosSelecioandos();
          }, 700);
        }
      });
    }
  }
  countJustificativa(event: any) {
    let textArea = event;
    let characterCounter = document.getElementById('char_count_' + event.currentTarget.id)!;
    const maxNumOfChars = 200
    textArea.addEventListener("input", this.countCharacters(textArea, characterCounter, maxNumOfChars));
  }

  public countCharacters = (textArea, characterCounter, maxNumOfChars) => {
    let numOfEnteredChars = textArea.currentTarget.textLength
    let counter = maxNumOfChars - numOfEnteredChars;
    characterCounter.textContent = counter + "/200";
    if (counter <= 0) {
      characterCounter.style.color = "red";
    } else if (counter < 100) {
      characterCounter.style.color = "orange";
    } else {
      characterCounter.style.color = "green";
    }

  }

  async validarVotos() {
    let votosCandidatos = this.candidatosSelecionados;
    this.votos = votosCandidatos;
    this.justificados = false;
    let aux = true;

    this.votos.forEach(v => {
      if (v.votoJustificavel == true) {
        let campoJustificativa = document.getElementById("justificativa_voto_" + v.id) as HTMLInputElement
        if (campoJustificativa == null || campoJustificativa == undefined) {
          aux = false;
        } else if (campoJustificativa.value.trim() == null || campoJustificativa.value.trim() == undefined || campoJustificativa.value.trim() == "") {
          aux = false;
        } else {
          v.justificativa = campoJustificativa.value.trim();
        }
      } else {
        this.justificados = true;
      }
    });

    if (aux) {
      this.justificados = true;
    } else {
      this.messageService.add({ key: 'toast', severity: 'error', summary: 'Atenção', detail: 'É necessário justificar o voto.' });
      this.justificados = false;
    }
  }


  public async realizarVoto() {
    // deve permitir votar em apenas um candidato. O número de votos restantes são computados como votos brancos

    // if (this.candidatosSelecionados.length < this.cargo.quantidadeEleitos) {
    //   this.messageService.add({ key: 'toast', severity: 'error', summary: 'Informação', detail: 'Você precisa selecionar ' + this.cargo.quantidadeEleitos + ' candidato(s) para esse cargo.' });
    // } else {

    await this.validarVotos();

    if (this.justificados) {
      let msg;
      let aux = this.isAssembleia==true ? 'opções': 'candidatos';
      
      let votosRestantes = this.cargo.quantidadeEleitos - this.candidatosSelecionados.length;
      if (votosRestantes == 1) {
        msg = `Você pode selecionar até ${this.cargo.quantidadeEleitos} ` + aux + `, mas escolheu somente ${this.candidatosSelecionados.length}. Caso confirme, o voto remanescente será considerado como branco.<br>Deseja confirmar seu voto?`
      } else if (votosRestantes > 1) {
        msg = `Você pode selecionar até ${this.cargo.quantidadeEleitos} ` + aux + `, mas escolheu somente ${this.candidatosSelecionados.length}. Caso confirme, os ${votosRestantes} votos remanescentes serão considerados como brancos.<br>Deseja confirmar seu voto?`
      } else {
        msg = `Deseja confirmar seu voto?`
      };

      this.confirmationService.confirm({
        message: msg,
        accept: () => {
          this.votoUnique = true;
          this.votoServices.save(this.votos, this.token).then((votos: CandidatoVoto[]) => {
            this.votos = votos;
            this.messageService.add({ key: 'toast', severity: 'success', summary: 'Informação', detail: 'Voto realizado com sucesso' });
            setTimeout(() => {
              location.reload()
            }, 700);
          }, error => {
            this.messageService.add({ key: 'toast', severity: 'error', summary: 'Atenção', detail: 'Voto não computado' });
            setTimeout(() => {
              location.reload()
            }, 700);
          });
        },
        reject: () => {
          this.desabilitaBotao = true;
          this.messageService.add({ key: 'toast', severity: 'warn', summary: 'Informação', detail: 'Operação cancelada!' });
          setTimeout(() => {
            this.limparCandidatosSelecioandos();
          }, 700);
        }
      });
      this.votoUnique = false;
    }

    // }
  }
  /* Fim Realizar Voto*/

}
